import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import NewsCard from '../components/NewsCard';
import RegionFilter from '../components/RegionFilter';
import { motion } from 'framer-motion';
import { getRegionName } from '../utils/labels';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Region() {
  const { regionId } = useParams();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [regionName, setRegionName] = useState('');

  useEffect(() => {
    fetchRegionNews();
  }, [regionId]);

  const fetchRegionNews = async () => {
    try {
      const response = await axios.get(`${API}/news?region=${regionId}&limit=50`);
      setNews(response.data);
      
      const regionsRes = await axios.get(`${API}/regions`);
      const reg = regionsRes.data.find(r => r.id === regionId);
      setRegionName(reg ? reg.name : regionId);
    } catch (error) {
      console.error('Failed to fetch region news:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" data-testid="loading-indicator">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0055FF]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA] dark:bg-[#0A0A0A] py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <RegionFilter activeRegion={regionId} />
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#09090B] dark:text-[#FAFAFA] mb-8">
            {getRegionName(regionId)}
          </h1>

          {news.length === 0 ? (
            <p className="text-center text-[#52525B] dark:text-[#A1A1AA]">Keine Nachrichten in dieser Region</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="region-news-grid">
              {news.map((item, idx) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: idx * 0.05 }}
                >
                  <NewsCard news={item} />
                </motion.div>
              ))}
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
}

export default Region;
